import React from 'react';
import logo from '../../../assets/SchoolLink-logo-web.png';

interface CreateNewPasswordFormProps {
  password: string;
  confirmPassword: string;
  error: string | null;
  isLoading: boolean;
  onPasswordChange: (password: string) => void;
  onConfirmPasswordChange: (confirmPassword: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

const CreateNewPasswordForm: React.FC<CreateNewPasswordFormProps> = ({
  password,
  confirmPassword,
  error,
  isLoading,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  onCancel
}) => {
  return (
    <form method="post" onSubmit={onSubmit}>
      <div className="text-center pb-4">
        <img style={{ width: "70%" }} src={logo} className="rounded" alt="SchoolLink Logo" />
      </div>
      
      <div className="form-group">
        <label htmlFor="newPassword">Password*</label>
        <input
          type="password"
          id="newPassword"
          className="form-control"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          disabled={isLoading}
          required
        />
        
        <label htmlFor="confirmNewPassword">Confirm Password*</label>
        <input
          type="password"
          id="confirmNewPassword"
          className="form-control"
          value={confirmPassword}
          onChange={(e) => onConfirmPasswordChange(e.target.value)}
          disabled={isLoading}
          required
        />
      </div>

      {error && (
        <span className="alert alert-danger" style={{ color: "#f00", fontSize: '14px' }}>
          {error}
        </span>
      )}

      <div className="col-12">
        <button
          type="button"
          style={{ marginTop: "7px" }}
          className="pull-left btn btn-outline-danger btn-lg btn-block"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="submit"
          style={{ marginTop: "7px" }}
          className="pull-right bg-gradient-theme-left border-0 btn btn-primary btn-lg btn-block"
          disabled={isLoading}
        >
          {isLoading ? 'Resetting...' : 'Reset Password'}
        </button>
      </div>
    </form>
  );
};

export default CreateNewPasswordForm;
